import type { SportsFeaturedState } from './types';

export const defaultState: SportsFeaturedState = {
  isLoading: false,
  preloaded: false
};
